import { render, staticRenderFns } from "./FormOfPaymentProfile.vue?vue&type=template&id=6e7e34a6"
import script from "./FormOfPaymentProfile.vue?vue&type=script&lang=js"
export * from "./FormOfPaymentProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports